import { getCurrentDayForSchoolyear } from 'containers/CahierJournal/utils/schoolyearDateUtils';
import { getMutualWorkingDays } from 'containers/utils';
import { School } from 'types/school';
import { Schoolyear } from 'types/schoolyear';
import { getDayBasedOnWorkingDays } from 'utils/time';
import { addYearsPreserveWeekAndDay } from 'utils/time/addYearsPreserveWeekAndDay';
import getDateFromCJUrl from 'utils/time/getDateFromCJUrl';
import { fixRedirect } from './fixRedirect';

function setSchoolyearAndSchoolInUrl({
  url,
  prevSchoolYear,
  nextSchoolYear,
  nextSchool,
}: {
  url: string;
  prevSchoolYear: Schoolyear;
  nextSchoolYear: Schoolyear;
  nextSchool: School;
}): string {
  const urlSplited = url.split('/');

  urlSplited[2] = nextSchoolYear.id;
  urlSplited[4] = nextSchool.id;

  if (urlSplited.includes('cahier-journal')) {
    const prevDate = getDateFromCJUrl(
      urlSplited[7],
      urlSplited[8],
      urlSplited[9],
    );

    const nextDate = getCurrentDayForSchoolyear(prevDate, nextSchoolYear);

    // if we can't define a date based on périodes, we fallback on offset navigation
    const yearOffset = nextSchoolYear.year - prevSchoolYear.year;
    const nextDateFallback = addYearsPreserveWeekAndDay(prevDate, yearOffset);

    const workedDay = getDayBasedOnWorkingDays(
      nextDate || nextDateFallback,
      getMutualWorkingDays(nextSchool.classrooms),
    );

    urlSplited[7] = workedDay.getFullYear().toString();
    urlSplited[8] = String(workedDay.getMonth() + 1).padStart(2, '0');
    urlSplited[9] = String(workedDay.getDate()).padStart(2, '0');
  }

  return fixRedirect(urlSplited.join('/'));
}

export { setSchoolyearAndSchoolInUrl };
